const INITIAL_STATE = [
    {
        visibleAgendamento: null,
        visibleAgendamentoInfo: null,
        visibleAgendamentosPorPeriodo: null,
        visibleRealizarAtendimento: null,
        visiblePreCadastro: null,
        visibleNovoFeriado: null,
        visibleEditarFeriado: null,
        visibleEditarServico: false,
        visibleNovoModulo: false,
        visibleNovoOrgao: false,
        visibleEditarOrgao: false,
        modulo: null,
        dataInfo: null,
        data: null,
        orgao: null,
        periodo: null,
        agendamento: null,
        feriado: null,
        servico: null,
        agendamentosDoDia: null,
        dataSelecionada: null
    },
];


export default function modalStatus(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_AGENDAMENTO_MODAL':
            return [{ visibleAgendamento: action.payload.status, dataInfo: action.payload.dataInfo }];
        case 'SET_AGENDADOS_MODAL':
            return [{ visibleAgendados: action.payload.status, data: action.payload.data, dataSelecionada: action.payload.dataSelecionada }];
        case 'SET_AGENDAMENTOS_POR_PERIODO_MODAL':
            return [{ visibleAgendamentosPorPeriodo: action.payload.status, data: action.payload.periodo }];
        case 'SET_PRECADASTRO_MODAL':
            return [{ visiblePreCadastro: action.payload.status }];
        case 'SET_AGENDAMENTOINFO_MODAL':
            return [{ visibleAgendamentoInfo: action.payload.status, agendamento: action.payload.agendamento, agendamentosDoDia: action.payload.agendamentosDoDia }];
        case 'SET_NOVOFERIADO_MODAL':
            return [{ visibleNovoFeriado: action.payload.status }];
        case 'SET_EDITARFERIADO_MODAL':
            return [{ visibleEditarFeriado: action.payload.status, feriado: action.payload.feriado }];
        case 'SET_NOVOSERVICO_MODAL':
            return [{ visibleNovoServico: action.payload.status }];
        case 'SET_EDITARSERVICO_MODAL':
            return [{ visibleEditarServico: action.payload.status, servico: action.payload.servico }];
        case 'SET_NOVOMODULO_MODAL':
            return [{ visibleNovoModulo: action.payload.status }];
        case 'SET_EDITARMODULO_MODAL':
            return [{ visibleEditarModulo: action.payload.status, modulo: action.payload.modulo }];
        case 'SET_NOVOORGAO_MODAL':
            return [{ visibleNovoOrgao: action.payload.status }];
        case 'SET_EDITARORGAO_MODAL':
            return [{ visibleEditarOrgao: action.payload.status, orgao: action.payload.values }];
        case 'SET_NOVOVINCULOORGAOSERVICO_MODAL':
            return [{ visibleNovoVinculoOrgaoServico: action.payload.status }];
        case 'SET_REALIZARATENDIMENTO':
            return [{ visibleRealizarAtendimento: action.payload.status }];
        default:
            return state;
    }
}